// extracted by mini-css-extract-plugin
export default {"contentPanel":"Content_contentPanel__MYvs4"};